import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Copy, ExternalLink, Youtube } from "lucide-react";
import { toast } from "sonner";

const SonicSprountPage = () => {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(text);
    toast.success("Link copiado para a área de transferência!");
    setTimeout(() => setCopied(null), 2000);
  };

  const videos = [
    {
      titulo: "CANAL DE GATOS NO RUMBLE 1",
      link: "https://www.youtube.com/watch?v=sj9vd83Q5V8",
      thumbnail: "https://i.ytimg.com/vi/sj9vd83Q5V8/hqdefault.jpg",
      descricao: "Conheça o canal de gatos no Rumble"
    },
    {
      titulo: "Criando canal musical 1",
      link: "https://www.youtube.com/watch?v=sD2PgeQiPJ8",
      thumbnail: "https://i.ytimg.com/vi/sD2PgeQiPJ8/hqdefault.jpg",
      descricao: "Aprenda a criar um canal musical no YouTube - Parte 1"
    },
    {
      titulo: "Criando canal musical 2",
      link: "https://www.youtube.com/watch?v=GWG_WLyRL0g",
      thumbnail: "https://i.ytimg.com/vi/GWG_WLyRL0g/hqdefault.jpg",
      descricao: "Aprenda a criar um canal musical no YouTube - Parte 2"
    },
    {
      titulo: "Criando canal musical",
      link: "https://www.youtube.com/watch?v=UGdGoSbg9d8",
      thumbnail: "https://i.ytimg.com/vi/UGdGoSbg9d8/hqdefault.jpg",
      descricao: "Dicas gerais para criar um canal musical"
    },
    {
      titulo: "Banner para YouTube de música de jazz com estilo monolinha em preto e branco 4",
      link: "https://www.youtube.com/watch?v=pIxgVSURhz0",
      thumbnail: "https://i.ytimg.com/vi/pIxgVSURhz0/hqdefault.jpg",
      descricao: "Tutorial para criar banners para canal de música de jazz - Parte 4"
    },
    {
      titulo: "Banner para YouTube de música de jazz com estilo monolinha em preto e branco 3",
      link: "https://www.youtube.com/watch?v=8Qu9WlbZojE",
      thumbnail: "https://i.ytimg.com/vi/8Qu9WlbZojE/hqdefault.jpg",
      descricao: "Tutorial para criar banners para canal de música de jazz - Parte 3"
    },
    {
      titulo: "Banner para YouTube de música de jazz com estilo monolinha em preto e branco 1",
      link: "https://www.youtube.com/watch?v=su4hD81B788",
      thumbnail: "https://i.ytimg.com/vi/su4hD81B788/hqdefault.jpg",
      descricao: "Tutorial para criar banners para canal de música de jazz - Parte 1"
    },
    {
      titulo: "Sonic Sprount Canal",
      link: "https://www.youtube.com/watch?v=H7SJU4FhJE8",
      thumbnail: "https://i.ytimg.com/vi/H7SJU4FhJE8/hqdefault.jpg",
      descricao: "Introdução ao canal Sonic Sprount"
    }
  ];

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Sonic Sprount
          </h1>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Canal de música, tutoriais e entretenimento no YouTube
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <Card className="w-full max-w-3xl overflow-hidden border border-border">
            <CardHeader className="bg-muted/50">
              <CardTitle className="text-xl flex items-center">
                <Youtube className="mr-2 h-5 w-5 text-primary" /> Sonic Sprount
              </CardTitle>
              <CardDescription>
                Canal dedicado a tutoriais sobre criação de conteúdo musical, banners e dicas para YouTubers
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="aspect-video overflow-hidden bg-muted rounded-md mb-4">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/H7SJU4FhJE8"
                  title="Sonic Sprount Canal"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
              <div className="space-y-4">
                <p>
                  Bem-vindo ao canal Sonic Sprount! Aqui você encontrará diversos tutoriais sobre:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Criação de canais musicais no YouTube</li>
                  <li>Design de banners e miniaturas para vídeos</li>
                  <li>Tutoriais sobre edição de áudio e vídeo</li>
                  <li>Dicas para crescer no YouTube</li>
                </ul>
              </div>
            </CardContent>
            <CardFooter className="flex gap-2 flex-wrap">
              <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                <a
                  href="https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ExternalLink size={16} className="mr-1" /> Visitar no YouTube
                </a>
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleCopy("https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig")}
                className={copied === "https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig" ? "bg-primary/10" : ""}
              >
                <Copy size={16} className="mr-1" />
                {copied === "https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig" ? "Copiado!" : "Copiar Link"}
              </Button>
            </CardFooter>
          </Card>
        </div>

        <Tabs defaultValue="videos" className="w-full mt-12">
          <div className="flex justify-center mb-8">
            <TabsList>
              <TabsTrigger value="videos">Vídeos</TabsTrigger>
              <TabsTrigger value="sobre">Sobre o Canal</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="videos" className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((video, index) => (
                <Card key={index} className="overflow-hidden border border-border h-full flex flex-col">
                  <div className="aspect-video overflow-hidden bg-muted">
                    <img
                      src={video.thumbnail}
                      alt={video.titulo}
                      className="w-full h-full object-cover transition-transform hover:scale-105"
                    />
                  </div>
                  <CardHeader>
                    <CardTitle className="text-lg">{video.titulo}</CardTitle>
                    <CardDescription>{video.descricao}</CardDescription>
                  </CardHeader>
                  <CardFooter className="mt-auto">
                    <Button
                      asChild
                      className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
                    >
                      <a
                        href={video.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <ExternalLink size={16} className="mr-1" /> Assistir
                      </a>
                    </Button>
                  </CardFooter>
                </Card>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="sobre" className="space-y-6">
            <Card className="border border-border">
              <CardHeader>
                <CardTitle>Sobre o Sonic Sprount</CardTitle>
                <CardDescription>
                  Tudo o que você precisa saber sobre o canal
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium mb-2">Nossa Missão</h3>
                  <p className="text-muted-foreground">
                    O canal Sonic Sprount tem como missão ajudar criadores de conteúdo a desenvolverem seus canais musicais no YouTube,
                    fornecendo tutoriais detalhados, dicas práticas e recursos úteis.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-lg font-medium mb-2">Conteúdo</h3>
                  <p className="text-muted-foreground">
                    Nosso conteúdo foca em:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 text-muted-foreground mt-2">
                    <li>Tutoriais de design para canais musicais</li>
                    <li>Criação de banners e miniaturas atrativas</li>
                    <li>Estratégias para crescimento no YouTube</li>
                    <li>Dicas sobre edição de áudio e vídeo</li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="text-lg font-medium mb-2">Frequência</h3>
                  <p className="text-muted-foreground">
                    Novos vídeos são publicados semanalmente. Inscreva-se no canal e ative as notificações para não perder nenhuma novidade.
                  </p>
                </div>
              </CardContent>
              <CardFooter>
                <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                  <a
                    href="https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Youtube size={16} className="mr-1" /> Inscrever-se
                  </a>
                </Button>
              </CardFooter>
            </Card>
          </TabsContent>
        </Tabs>
        
        <div className="text-center mt-12">
          <h2 className="text-2xl font-semibold mb-4">Inscreva-se no Canal</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto mb-6">
            Acompanhe o canal Sonic Sprount para receber as melhores dicas sobre criação de conteúdo musical e design para o YouTube.
          </p>
          <Button 
            asChild 
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <a 
              href="https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Youtube className="mr-2 h-5 w-5" /> Se inscreve no canal Sonic Sprount
            </a>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SonicSprountPage;